import React from 'react';
import { MenuItem, TextField, TextFieldProps, SelectProps } from '@mui/material';

type SelectInputProps = Omit<TextFieldProps, 'select'> & {
  options?: { key: string | number; value: string }[];
  multiple?: boolean;
  renderValue?: (selected: any) => React.ReactNode;
};

const SelectInput = React.memo<SelectInputProps>(({
  options,
  sx,
  children,
  size,
  multiple,
  renderValue,
  ...props
}) => {

  // Let MUI Select manage open state. Controlling `open` + custom onFocus/onClose fought
  // the native behavior and caused focus / re-open issues after selecting an option.
  const selectProps: SelectProps = {
    MenuProps: {
      anchorOrigin: { 
        vertical: 'bottom', 
        horizontal: 'left' 
      },
      transformOrigin: { 
        vertical: 'top', 
        horizontal: 'left' 
      },
      PaperProps: {
        sx: { 
          maxHeight: 320,
          mt: 0.5,
        },
      },
    },
    ...(multiple !== undefined && { multiple }),
    ...(renderValue && { renderValue }),
  };

  return (<TextField
    select
    fullWidth
    size={size}
    SelectProps={selectProps}
    sx={{
      ...sx,
      width: '100%',
    }}
    {...props}
  >
    {options?.map(({ key, value }) => (
      <MenuItem key={key} value={value}>
        {key}
      </MenuItem>
    ))}
    {children}
  </TextField>
  );
});

SelectInput.displayName = 'SelectInput';

export default SelectInput;
